import styled from "styled-components";
import { colors } from "@/theme";

export const CartItemRow = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${colors.silverSand};
  gap: 16px;
`;

export const CartItemProduct = styled.div`
  flex: 0 0 70px;
  display: flex;
  align-items: center;
`;

export const CartItemDetails = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CartItemName = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
`;

export const CartItemSku = styled.div`
  color: ${colors.neutralGrey500};
  font-size: 12px;
  font-family: "PF DIN Text Pro";
  font-weight: 400;
`;

export const CartItemPriceInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const CartItemCounter = styled.div`
  flex: 0 0 80px;
  display: flex;
  justify-content: center;
`;

export const CartItemShipping = styled.div`
  flex: 0 0 140px;
  display: flex;
  justify-content: center;
`;

export const CartItemSubtotalInfo = styled.div`
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const CartItemPrice = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CartItemCoopAmountGroup = styled.div``;

export const CartItemCoopAmountGroupFieldset = styled.fieldset`
  border: 1px solid ${colors.silverSand};
  border-radius: 12px;
`;

export const CartItemCoopAmountGroupLegend = styled.legend`
  width: auto;
  margin-left: auto;
  margin-right: auto;
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;

export const CartItemPropertiesContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
`;

export const CartItemSubtotal = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CartItemEligibleCoop = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CartItemRemainingBalance = styled.div`
  color: ${colors.black};
  text-align: right;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const CartItemInfoBlock = styled.div`
  flex: 2;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
`;
